import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHEPOOL_GIT__SET_PROJECTS':
            return core.setProjects(state, action.projects);
        case 'FHEPOOL_GIT__SET_PROJECT':
            return core.setProject(state, action.project);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/Projects/reducer.js